import * as React from 'react';

import { cn } from '@/lib/utils';

interface DataSurfaceProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Compact data surfaces should feel like an operational plane, not a card.
   * Keep the chrome quiet: one keyline, one background, no nested padding.
   */
  children: React.ReactNode;
}

export function DataSurface({ children, className, ...props }: DataSurfaceProps) {
  return (
    <div
      className={cn(
        'overflow-hidden rounded-lg border border-border/80 bg-card text-card-foreground',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}

